module.exports = __webpack_public_path__ + "img/pensil_dark_grey.0903ccad.jpeg";